export default __webpack_public_path__ + "static/media/course_slides_notebook_big.fd825b5d.png";